export default {
  dbi_casual_genre_profile: '休闲品类画像',
  dbi_casual_genre_profile_sub_title: '如有疑问可联系GRC tedni',
  dbi_casual_genre_breakdown: '品类占比',
  // MetricSegment
  dbi_casual_metric_download: '下载量',
  dbi_casual_metric_mau: '月活跃用户',
  dbi_casual_metric_revenue: '收入($)',
  // ChartsSection - SensorTower Main Genre
  dbi_casual_genre_share_main_genre: '品类占比 - 主品类',
  dbi_casual_genre_trend_main_genre: '品类趋势 - 主品类',
  // ChartsSection - SensorTower Sub Genre
  dbi_casual_genre_share_sub_genre: '品类占比 - 副品类',
  dbi_casual_genre_trend_sub_genre: '品类趋势 - 副品类',
  // ChartsSection - AppMagic Super Genre
  dbi_casual_genre_share_super_genre: '品类占比 - 游戏分类',
  dbi_casual_genre_trend_super_genre: '品类趋势 - 游戏分类',
  // ChartsSection - AppMagic Level-1 Genre (major_category)
  dbi_casual_genre_performance_level1_genre: '品类表现 - 一级品类',
  dbi_casual_genre_trend_level1_genre: '品类趋势 - 一级品类',
  // ChartsSection - AppMagic Level-2 Genre (mid_category)
  dbi_casual_genre_performance_level2_genre: '品类表现 - 二级品类',
  dbi_casual_genre_trend_level2_genre: '品类趋势 - 二级品类',
  // ChartsSection - AppMagic Level-3 Genre (sub_category)
  dbi_casual_genre_performance_level3_genre: '品类表现 - 三级品类',
  dbi_casual_genre_trend_level3_genre: '品类趋势 - 三级品类',

  // MetricDataGames
  dbi_casual_top_games: '热门游戏',
  dbi_casual_rising_games: '黑马游戏',
  dbi_casual_game: '游戏',

  // DimensionSelect
  dbi_casual_dimension_by_genre: '品类维度',
  dbi_casual_dimension_main_genre: '主品类',
  dbi_casual_dimension_sub_genre: '副品类',
  dbi_casual_dimension_super_genre: '游戏分类',
  dbi_casual_dimension_level1_genre: '一级品类',
  dbi_casual_dimension_level2_genre: '二级品类',
  dbi_casual_dimension_level3_genre: '三级品类',

  // TableSegment
  dbi_casual_table_segment_metrics: '指标',
  dbi_casual_table_segment_top_games: '头部游戏',
  dbi_casual_table_segment_rising_games: '黑马游戏',

  dbi_casual_noteworthy_games: '值得关注游戏',

  // GenreTable columns
  dbi_casual_table_col_main_genre: '主品类',
  dbi_casual_table_col_sub_genre: '副品类',
  dbi_casual_table_col_super_genre: '游戏分类',
  dbi_casual_table_col_level1_genre: '一级品类',
  dbi_casual_table_col_level2_genre: '二级品类',
  dbi_casual_table_col_level3_genre: '三级品类',
  dbi_casual_table_col_download: '下载量',
  dbi_casual_table_col_mau: '月活',
  dbi_casual_table_col_revenue: '收入($)',
  dbi_casual_table_col_top_games_by_download: '热门游戏（按下载量）',
  dbi_casual_table_col_top_games_by_dau: '热门游戏（按日活）',
  dbi_casual_table_col_top_games_by_wau: '热门游戏（按周活）',
  dbi_casual_table_col_top_games_by_mau: '热门游戏（按月活）',
  dbi_casual_table_col_top_games_by_revenue: '热门游戏（按收入）',
  dbi_casual_table_col_rising_games_by_download: '黑马游戏（按下载量）',
  dbi_casual_table_col_rising_games_by_dau: '黑马游戏（按日活）',
  dbi_casual_table_col_rising_games_by_wau: '黑马游戏（按周活）',
  dbi_casual_table_col_rising_games_by_mau: '黑马游戏（按月活）',
  dbi_casual_table_col_rising_games_by_revenue: '黑马游戏（按收入）',

  // GenreTableSearch
  dbi_casual_genre_table_search_placeholder: '在表格内搜索任意品类',

  // 黑马游戏解释提示 - 卡片顶部
  // 月粒度
  dbi_casual_rising_games_tip_monthly_download: '下载量黑马游戏：平均月下载 > 500k，变化率降序',
  dbi_casual_rising_games_tip_monthly_mau: '月活跃黑马游戏：平均月活跃 > 1M，变化率降序',
  dbi_casual_rising_games_tip_monthly_revenue: '收入黑马游戏：平均月收入($) > 200k, 变化率降序',
  // 日粒度
  dbi_casual_rising_games_tip_daily_download: '下载量黑马游戏：平均日下载 > 50k，变化率降序',
  dbi_casual_rising_games_tip_daily_dau: '日活跃黑马游戏：平均日活跃 > 500k，变化率降序',
  dbi_casual_rising_games_tip_daily_revenue: '收入黑马游戏：平均日收入($) > 10k，变化率降序',

  // 黑马游戏解释提示 - 表格列
  dbi_casual_rising_games_col_tip_monthly_download: '下载量黑马游戏：平均月下载 > 500k，变化率降序',
  dbi_casual_rising_games_col_tip_daily_download: '下载量黑马游戏：平均日下载 > 50k，变化率降序',
  dbi_casual_rising_games_col_tip_dau: '日活跃黑马游戏：平均日活跃 > 500k，变化率降序',
  dbi_casual_rising_games_col_tip_mau: '月活跃黑马游戏：平均月活跃 > 1M，变化率降序',
};
